<template>
  <div class="processing">
    <div class="processing_top">
      <ToProcessed />
    </div>
    <div class="processing_bottom container_width">
      <div class="processing_title">举报处理</div>
      <div class="processing_form">
        <el-form :model="ruleForm" ref="ruleForm" label-width="120px" class="demo-ruleForm">
          <el-form-item label="事项处理过程">
            <el-input
              type="textarea"
              :autosize="{ minRows: 4}"
              v-model="ruleForm.handleProcessDesc"
              placeholder="请输入事项处理过程"
            ></el-input>
          </el-form-item>
          <el-form-item label="对入驻机构采取的措施">
            <el-input
              type="textarea"
              :autosize="{ minRows: 4}"
              v-model="ruleForm.handleReportMeasure"
              placeholder="请输入事项处理过程"
            ></el-input>
          </el-form-item>
          <el-form-item label="资料">
            <a href="javascript:void(0);" class="input">
              上传附件
              <input type="file" class="file" @change="getFile($event)" />
            </a>
            <span class="currFile">{{currentFile}}</span>
          </el-form-item>
          <el-form-item class="el_alone_style" label>
            <el-checkbox-group v-model="ruleForm.dangerWarning">
              <el-checkbox :label="1" name="type">事中风险评估</el-checkbox>
              <el-checkbox :label="2" name="type2">基金风险预警</el-checkbox>
            </el-checkbox-group>
          </el-form-item>
          <div class="set_title">风险预警设置：</div>
          <el-form-item label="起始月份" class="data_style">
            <el-date-picker
              type="month"
              placeholder="选择日期"
              v-model="ruleForm.warningStartMonth"
              style="width: 100%;"
            ></el-date-picker>
          </el-form-item>
          <el-form-item label="有效期">
            <el-select v-model="ruleForm.monitorPeriod" placeholder="请选择时间">
              <el-option label="3个月" value="3"></el-option>
              <el-option label="6个月" value="6"></el-option>
              <el-option label="12个月" value="12"></el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="负面信息监控">
            <el-select v-model="ruleForm.productType" placeholder="请选择">
              <el-option
                v-for="item in types"
                :key="item.value"
                :label="item.label"
                :value="item.value"
              ></el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="是否自动续期">
            <el-radio-group v-model="ruleForm.renewalType">
              <el-radio label="是" :value="1"></el-radio>
              <el-radio label="否" :value="0"></el-radio>
            </el-radio-group>
          </el-form-item>
          <el-form-item class="reset_button">
            <el-button class="go_back" @click="goBack">取消</el-button>
            <el-button type="primary" @click="submitForm('ruleForm')">受理</el-button>
            <el-button @click="rejectHandler">驳回</el-button>
          </el-form-item>
        </el-form>
      </div>
    </div>
  </div>
</template>

<script>
import ToProcessed from "@/views/ReportPlatform/ToProcessed.vue";
import { handleReportDeal, rejectHandles } from "common/js/api";

export default {
  name: "Processing",
  components: {
    ToProcessed
  },
  data() {
    return {
      types: [
        {
          label: "负面信息监控",
          value: 1
        },
        {
          label: "工商信息监监控(有效期至少3个月)",
          value: 2
        }
      ],
      fileList: [],
      ruleForm: {
        handleProcessDesc: "",
        handleReportMeasure: "",
        dangerWarning: [],
        warningStartMonth: "",
        monitorPeriod: "",
        productType: "",
        renewalType: "",
        file: "",
        id: this.$route.query.id,
        companyName: this.$route.query.companyName,
        handleName: this.Cookies.get("operationName") || "测试人"
      },
      currentFile: "",
      rules: {
        desc: [
          { required: true, message: "请输入事项处理过程", trigger: "blur" }
        ],
        measure: [
          { required: true, message: "请输入事项处理过程", trigger: "blur" }
        ],
        date: [
          {
            type: "date",
            required: true,
            message: "请选择日期",
            trigger: "change"
          }
        ],
        region: [{ required: true, message: "请选择时间", trigger: "change" }],
        monitor: [{ required: true, message: "请选择信息", trigger: "change" }],
        type: [
          {
            type: "array",
            message: "请至少选择一个活动性质",
            trigger: "change"
          }
        ],
        resource: [
          { required: true, message: "请选择活动资源", trigger: "change" }
        ]
      }
    };
  },
  methods: {
    goBack() {
      this.$router.push("/ReportPlatform/Management");
    },

    getFile(event) {
      const file = event.target.files[0];
      this.ruleForm.file = file;
      this.currentFile = file.name;
    },

    submitForm(formName) {
      this.$refs[formName].validate(valid => {
        if (valid) {
          this.submit();
        } else {
          console.log("error submit!!");
          return false;
        }
      });
    },

    // 受理
    async submit() {
      const form = this.$lodash.cloneDeep(this.ruleForm);
      form.dangerWarning =
        form.dangerWarning.length == 2 ? 3 : form.dangerWarning[0] || "";

      let formData = new FormData();
      for (let key in form) {
        formData.append(key, form[key]);
      }
      await handleReportDeal(formData);
      this.$message({
        message: "受理成功",
        type: "success"
      });
      setTimeout(() => {
        this.$router.push("/ReportPlatform/Management");
      }, 500);
    },

    async rejectHandler() {
      await rejectHandles({ id: this.$route.query.id });
      this.$message({
        message: "驳回成功",
        type: "success"
      });
      setTimeout(() => {
        this.$router.push("/ReportPlatform/Management");
      }, 500);
    },

    resetForm(formName) {
      this.$refs[formName].resetFields();
    },

    handleRemove(file, fileList) {
    
    },

    handlePreview(file) {
      
    },

    handleExceed(files, fileList) {
      this.$message.warning(
        `当前限制选择 3 个文件，本次选择了 ${
          files.length
        } 个文件，共选择了 ${files.length + fileList.length} 个文件`
      );
    },

    beforeRemove(file, fileList) {
      return this.$confirm(`确定移除 ${file.name}？`);
    }
  }
};
</script>

<style scoped>
.processing_top >>> .deal_with {
  display: none;
}
.processing_top {
  border-bottom: 1px dashed #d5d5d5;
}
.processing_title {
  font-size: 28px;
  color: #0f1824;
  font-weight: bold;
  margin: 40px 0 30px;
}
.processing_form >>> .el-form-item__label {
  text-align: left;
  padding-top: 10px;
  line-height: inherit;
}
.processing_form >>> .el-form-item {
  margin-bottom: 25px !important;
}
.processing_form >>> .upload_style {
  border: 1px solid #3165ff;
  border-radius: 2px;
  background: #fff;
  font-size: 14px;
  color: #3165ff;
}
.set_title {
  font-size: 14px;
  color: #0f1824;
  font-weight: bold;
  margin-bottom: 30px;
}
.reset_button >>> .el-form-item__content,
.el_alone_style >>> .el-form-item__content {
  margin-left: 0 !important;
}
.reset_button >>> .el-form-item__content .el-button {
  width: 100px;
  /* height: 28px; */
  color: #fff;
  font-size: 12px;
  background: #3165ff;
  border-radius: 2px;
}
.reset_button >>> .el-form-item__content .go_back {
  color: #6c7885;
  background: #fff;
  border: 1px solid #dddddd;
}
.data_style >>> .el-date-editor {
  width: 214px !important;
}
/* upload */
.form {
  text-align: center;
}
.file_name {
  width: 50%;
  text-indent: 10px;
  border: 1px solid #ccc;
  height: 30px;
}

a.input {
  border-radius: 2px;
  box-sizing: border-box;
  /* width: 70%;
  height: 115px; */
  text-align: center;
  cursor: pointer;
  position: relative;
  overflow: hidden;
  display: inline-block;
}

a {
  text-decoration: none;
  border: 1px solid #3165ff;
  padding: 10px 20px;
  line-height: 10px;
  color: #3165ff;
}

.file {
  opacity: 0;
  /*设置此控件透明度为零，即完全透明*/
  filter: alpha(opacity=0);
  /*设置此控件透明度为零，即完全透明针对IE*/
  font-size: 100px;
  cursor: pointer;
  position: absolute;
  /*绝对定位，相对于 .input */
  top: 0;
  right: 0;
}
.currFile {
  display: inline-block;
  vertical-align: text-bottom;
  padding: 0px 20px;
}
</style>
